// src/App.jsx

import React from "react";
import { BrowserRouter as Router, Routes, Route,} from "react-router-dom";
// import Home from "./components/Home";
import AddEmployeeForm from "./Page/AddEmployeeForm";

import Login from "./components/Login";
import Main from "./Page/Main";
import SalaryDeatails from "./Page/SalaryDeatails";
import SalaryQrAdd from "./Page/Salary/SalaryQrAdd";
import Salary from "./Page/Salary/Salary";
import AdvanceSalary from "./Page/Salary/AdvanceSalary";
import Attendance from "./Page/Attendance/Attendance";

import AdminProfileView from "./Page/Profile/AdminProfileView";
import AdminAttendance from "./Page/Attendance/AdminAttendance";

function App() {
  return (
    <Router>
     

      <Routes>
        <Route path="/dashboard" element={<Main/>} />
       <Route path="/addsalaryqr" element={<SalaryQrAdd/>} />
        <Route path="/addemployee" element={<AddEmployeeForm/>} />
        <Route path="/salarydetails" element={<SalaryDeatails/>} />
        <Route path="/advancesalary" element={<AdvanceSalary/>} />
        <Route path="/employ/salary" element={<Salary/>} />
        <Route path="/employ/attendance" element={<Attendance/>} />
        <Route path="/admin/attendance" element={<AdminAttendance/>} />



        <Route path="/admin/profileview" element={<AdminProfileView/>} />
        <Route path="/" element={<Login/>} />
      </Routes>
    </Router>
  );
}

export default App;
